// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hat-card-drop-down {
  color: #0b4c95;
  font-weight: 625;
  text-transform: uppercase;
  border: 0.3px solid transparent;
  transition: all 1s;
}

.hat-card-drop-down:hover {
  color: orange;
  transform: translateY(-3%);
}

.hat-card-drop-down {
  width: calc(20% - 20px);
}

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
    sm, small: 600px
    md, medium: 900px
    lg, large: 1200px
    xl, extra-large: 1536px */

  @media only screen and (max-width: 844px) {
    .hat-card-drop-down {
      width: calc(33% - 20px);
    }
  }

  @media only screen and (max-width: 599px) {
    .hat-card-drop-down {
      width: calc(50% - 20px);
    }
  }

  @media only screen and (max-width: 499px) {
    .hat-card-drop-down {
      width: calc(70% - 20px);
    }
  }

  @media only screen and (min-width: 845px) {
    .hat-card-drop-down {
      width: calc(25% - 20px);
    }
  }

  @media only screen and (min-width: 1000px) {
    .hat-card-drop-down {
      width: calc(25% - 20px);
    }
  }

  @media only screen and (min-width: 1200px) {
    .hat-card-drop-down {
      width: calc(20% - 20px);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Products/HatCard/HatCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE;;;;6BAI2B;;EAE3B;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;EACF;AACF","sourcesContent":[".hat-card-drop-down {\n  color: #0b4c95;\n  font-weight: 625;\n  text-transform: uppercase;\n  border: 0.3px solid transparent;\n  transition: all 1s;\n}\n\n.hat-card-drop-down:hover {\n  color: orange;\n  transform: translateY(-3%);\n}\n\n.hat-card-drop-down {\n  width: calc(20% - 20px);\n}\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n    sm, small: 600px\n    md, medium: 900px\n    lg, large: 1200px\n    xl, extra-large: 1536px */\n\n  @media only screen and (max-width: 844px) {\n    .hat-card-drop-down {\n      width: calc(33% - 20px);\n    }\n  }\n\n  @media only screen and (max-width: 599px) {\n    .hat-card-drop-down {\n      width: calc(50% - 20px);\n    }\n  }\n\n  @media only screen and (max-width: 499px) {\n    .hat-card-drop-down {\n      width: calc(70% - 20px);\n    }\n  }\n\n  @media only screen and (min-width: 845px) {\n    .hat-card-drop-down {\n      width: calc(25% - 20px);\n    }\n  }\n\n  @media only screen and (min-width: 1000px) {\n    .hat-card-drop-down {\n      width: calc(25% - 20px);\n    }\n  }\n\n  @media only screen and (min-width: 1200px) {\n    .hat-card-drop-down {\n      width: calc(20% - 20px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
